import styled from 'styled-components';

export const FittedViewContainer = styled.div`
  background: ${({ theme }) => theme.token('background-default')};
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  padding-block-start: 0;
  height: 100%;
`;
